import { DocumentAPI } from '../../api/DocumentAPI';

export class DocumentCommand {
    getLineScheduleDocument(id, successCallback, errorCallback) {
        const apiResult = DocumentAPI.getLineScheduleDocument(id);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    getLineDirectionScheduleDocument(code, direction, successCallback, errorCallback) {
        const apiResult = DocumentAPI.getLineDirectionScheduleDocument(code, direction);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    downloadLineScheduleDocument(document, successCallback, errorCallback) {
        const apiResult = DocumentAPI.downloadLineScheduleDocument(document);
        apiResult.then(async (result) => {
            if (undefined !== successCallback) {
                successCallback(await result.blob());
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }
}